// extracted by mini-css-extract-plugin
export default {"gradientText":"GradientText_gradientText__2L15W","gradientAnimation":"GradientText_gradientAnimation__BbmfX"};